import { httpAviationProdService, httpAviationService, httpDomainService, httpDomainClientService } from "../http-service";


const getCorporateRegion = async (objISearch: ISearch) => {
  const params = JSON.stringify({
    search: objISearch.search,
    sortBy: objISearch.sortBy,
    sortOrder: objISearch.sortOrder,
    filterBy: {
      columnName: "",
      columnValue: ""
    },
    paginationInfo: {
      perPage: objISearch.pagination.perPage,
      page: objISearch.pagination.page,
    },
  });

  const data = await httpDomainService.post<IPaginationResult<ICorporateRegion>>(
    "/corporate_region/get",
    params,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
      },
    }
  );
  
  return data.data;
};



const getFireNumbers = async (search:string, year: string = (new Date()).getFullYear().toString()) => {
  //const currentYear: number = new Date().getFullYear();
  const request: FireNumberSearchRequest = {
    search: search,
    year: year,
    paginationInfo: {
      perPage: 200000,
      page: 1,
    }
  };
  const params = JSON.stringify(request);

  const response = await httpAviationProdService.post<ApiResponse>(
    `/fire-number/get`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  const extractedFireNumbers = response.data?.data?.map((item: DataItem) => ({ fireNumber: item.fireNumber, year: item.year }));
  return extractedFireNumbers?.sort((a, b) => a.fireNumber.localeCompare(b.fireNumber));
};

const getCrewTypes = async (search:string) => {
  //const currentYear: number = new Date().getFullYear();
  const request: CrewTypeSearchRequest = {
    lookupTypeIds: Number(process.env.REACT_APP_OCP_DOMAIN_TABLE_CLIENT_LOOKUP_CREWTYPE),
    currentDate: new Date().toISOString().split('T')[0], // Format as YYYY-MM-DD
  };

  const response = await httpDomainClientService.get(
    `/lookup/type/all-fields?lookupTypeIds=${request.lookupTypeIds}&currentDate=${request.currentDate}`
  );
  const allCrewTypes = response?.data?.map((item: any) => ({ crewTypeId: item.Id, crewTypeName: item.Description, code: item.Code, oracleId: item.OracleId }));
  // const filteredCrewTypes = allCrewTypes?.filter((item: any) => item.crewTypeName.toLowerCase().includes(search.toLowerCase()));
  // if (filteredCrewTypes.length === 0) {
  //   return [];
  // }
  return allCrewTypes?.sort((a: any, b: any) => a.crewTypeName.localeCompare(b.crewTypeName));
};

const getCrewNumbers = async (search:string, crewTypeId: number | undefined) => {
  //const currentYear: number = new Date().getFullYear();
  const request: CrewNumberSearchRequest = {
    crewTypeId: crewTypeId, // Assuming this is optional
    search: search,
    paginationInfo: {
      perPage: 1000,
      page: 1,
    }
  };
  const params = JSON.stringify(request);

  const response = await httpAviationService.post<ApiResponse>(
    `/crew-number/get`,
    params,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  const crewNumbers = response.data?.data?.map((item: any) => ({ crewId: item.id, crewNumber: item.crewNumber, crewTypeId: item.crewType }));
  return crewNumbers?.sort((a, b) => a.crewNumber.localeCompare(b.crewNumber));
};

interface PaginationInfo {
  perPage: number;
  page: number;
}



export interface FireNumberSearchRequest {
  search: string;
  year: string;
  paginationInfo: PaginationInfo;
}

export interface CrewTypeSearchRequest {
  lookupTypeIds: number;
  currentDate: string;
}

export interface CrewNumberSearchRequest {
  crewTypeId?: number;
  search: string;
  paginationInfo: PaginationInfo;
}



interface DataItem {
  id: number;
  fireNumber: string;
  year: number;
  carryOver: string;
}

interface ApiResponse {
  status: string;
  errorCodeId: string;
  errorMessage: string;
  paginationInfo: PaginationInfo;
  data: DataItem[];
}




export const ExternalService = {
  getFireNumbers,
  getCorporateRegion,
  getCrewTypes,
  getCrewNumbers,
};

export interface IPagination {
  perPage: number,
  page:number,
  totalPages?:number,
  total?:number 
};

export interface IPaginationResult<T>
  {
    status?:string | undefined,
    errorCodeId:string,
    errorMessage:string,
    paginationInfo:IPagination,
    data: T[]
  };


  export interface ICorporateRegion{
    corporateRegionId:string,
    crt_id:string,
    name:string,
    effective_date:string | undefined,
    termination_date?:string | undefined,

    create_userid?:string | undefined,
    create_timestamp?:Date | undefined,
    update_timestamp?:Date | undefined,
    update_userid?: string | undefined,   
} 

export interface IForestArea {
    corporateRegionId:string[],
}
 
 

export interface IFilter{
    columnName: string,
    columnValue: string,
    reportDateFrom?:string | null,
    reportDateTo?:string | null,
    corporateRegions?:IForestArea,
    negotiated?:boolean
};

export interface ISearch {
    serviceName?:string | undefined,
    search?: string | undefined,
    sortBy?:string,
    sortOrder?:string,
    filterBy?:IFilter,
    pagination:IPagination, 
  };
